import * as React from 'react';
import { SelectListItem } from '../../models/utilities/selectlist-item';
import { InputFeedback } from './InputFeedback';
import { InputLabel } from './InputLabel';

// #region Component Props

interface IProps<T> {
    id          : string;
    label       : string;
    value       : any;
    onChange    : any;
    options     : Array<SelectListItem<T>>;
    className?  : string;
    error?      : string;
    disable?    : boolean;
    name?       : string;
    onBlur?     : any;
    testID?     : string;
    default?    : any;

}

// #endregion

export class SelectInput<T extends number|string> extends React.Component<IProps<T>> {

    public static defaultProps = {
        className   : '',
        error       : '',
        disable     : false,
        name        : '',
        onBlur      : undefined,
        testID      : '',
        default     : undefined
    };

    public render() {

        const { 
            className, 
            id, 
            error, 
            label, 
            value, 
            onChange, 
            options, 
            disable, 
            name,
            onBlur,
            testID
        } = this.props;
        
        const noValue = (value === undefined) || (value === null);

        return (
            <div className={'form-group ' + (className)}>
                <InputLabel htmlFor={id} error={error}>
                    {label}
                </InputLabel>
                <select
                    id={id}
                    disabled={ disable }
                    name={ name }
                    data-testid={ testID }
                    className={"form-control" + (error ? ' error-outline' : '')}
                    value={noValue ? '' : value }
                    onChange={onChange}
                    onBlur={ onBlur }>
                    <option id={undefined} value={this.props.default}>Choose...</option>
                    {
                        options.map((itm: SelectListItem<T>) => (
                            <option key={itm.id} value={itm.id}>{itm.name}</option>
                        ))
                    }
                </select>
                <InputFeedback error={error} />
            </div>
        );
    }
}
